import Vue from 'vue'
import Router from 'vue-router'
import About from '../views/About.vue'
import {Users} from 'dync-users';

Vue.use(Router)

export default new Router({
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [
    {
      path: '/',
      name: 'root',
      redirect: { name: 'public-auctions'}
    },
    {
      path: '/about',
      name: 'about',
      meta: {public: true},
      component: About
    },
    {
      path: '/users',
      name: 'users',
      props: {
        inviteEnabled: false,
        routedEditView: false
      },
      component: Users
    }
  ]
})
